import * as React from 'react';
import * as styles from './styles.css';

import { Text } from '../Text';
import { Container } from '../Container';

import { Item } from './Item';
import { DATA } from './data';

import { ActionWithHorizontalScroll } from '../ActionWithHorizontalScroll';
import { trackSwipe, EBlocks } from '../../analytics';

export function Models() {
  return (
    <div className={styles['container']}>
      <Container>
        <div className={styles['title']}>
          <Text size="h3" bold>
            Модели
          </Text>
        </div>
        <div className={styles['description']}>
          <Text>
            Глубокая экспертиза рынка недвижимости и машинного обучения позволяют нам разрабатывать уникальные
            высокоточные модели
          </Text>
        </div>
        <ActionWithHorizontalScroll action={() => trackSwipe(EBlocks.Models)}>
          <div className={styles['items-wrapper']}>
            <div className={styles['items']}>
              {DATA.map((item, index) => {
                const { title, text, withLabel } = item;

                return <Item key={index} title={title} text={text} withLabel={withLabel} />;
              })}
            </div>
          </div>
        </ActionWithHorizontalScroll>
      </Container>
    </div>
  );
}
